import { adjustmentTypes } from '../types/adjustmentTypes';

const initialState = {
  employeesInAdjustment: [],
  deleteAdjustmentEntitis: []
};

export const adjustmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case adjustmentTypes.ADD_EMPLOYEE_IN_ADJUSTMENT: {
      const { insertAfterIndex, ...employee } = action.payload;
      if (insertAfterIndex !== undefined) {
        const updated = [...state.employeesInAdjustment];
        updated.splice(insertAfterIndex + 1, 0, employee);
        return { ...state, employeesInAdjustment: updated };
      }
      return {
        ...state,
        employeesInAdjustment: [...state.employeesInAdjustment, employee]
      };
    }
    case adjustmentTypes.REMOVE_EMPLOYEE_IN_ADJUSTMENT:
      return {
        ...state,
        employeesInAdjustment: state.employeesInAdjustment.filter((employee) => employee.id !== action.payload.personId)
      };
    case adjustmentTypes.CHANGE_EMPLOYEE_VALUE: {
      const { id, key, value } = action.payload;
      return {
        ...state,
        employeesInAdjustment: state.employeesInAdjustment.map((employee) => {
          if (employee.id === id) {
            const updatedEmployee = { ...employee };
            updatedEmployee[key] = value;
            if (key === 'position') {
              updatedEmployee.pay = value.pay;
            }
            return updatedEmployee;
          }
          return employee;
        })
      };
    }
    case adjustmentTypes.DELETE_ADJUSTMENT: {
      const deletedAdjustments = [];
      const newEmployeesWithAdjustments = state.employeesInAdjustment.map((employee) => {
        if (employee.adjustmentEntities && employee.adjustmentEntities.length > 0) {
          const updatedAdjustmentEntities = employee.adjustmentEntities.filter((adjustment) => {
            if (adjustment.adjustmentId === action.payload) {
              deletedAdjustments.push(adjustment);
              return false;
            }
            return true;
          });
          return {
            ...employee,
            adjustmentEntities: updatedAdjustmentEntities
          };
        }
        return employee;
      });

      return {
        ...state,
        employeesInAdjustment: newEmployeesWithAdjustments,
        deleteAdjustmentEntitis: [
          ...state.deleteAdjustmentEntitis,
          ...deletedAdjustments // Agregar los ajustes eliminados a deleteAdjustmentEntitis
        ]
      };
    }
    case adjustmentTypes.ADDSAMEDATE: {
      const { pay, position, totalOtHour, totalRegHour, paymentDate, date, weekEnding, errors } = action.payload;

      const updatedEmployees = state.employeesInAdjustment.map((employee) => ({
        ...employee,
        pay,
        position,
        totalOtHour,
        totalRegHour,
        paymentDate,
        date,
        ...(weekEnding ? { weekEnding } : {}),
        errors
      }));

      return {
        ...state,
        employeesInAdjustment: updatedEmployees
      };
    }
    case adjustmentTypes.RESET_ENTIRE_STATE:
      return initialState;
    default:
      return state;
  }
};
